<app-help-page mainVideo="export-destinations"
               [tutorials]="['export-destination-sftp']"
               [videos]="['export-destinations', 'exports']"></app-help-page>
